interface TooltipProps {
  content: string;
  children: React.ReactNode;
}

export function Tooltip({ content, children }: TooltipProps) {
  return (
    <div className="group relative inline-block">
      {children}
      <div className="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-slate-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-150 group-hover:opacity-100 z-50">
        {content}
        {/* Flecha del tooltip */}
        <div className="absolute top-full left-1/2 -ml-1 border-4 border-transparent border-t-slate-900" />
      </div>
    </div>
  );
}
